<template>
  <div id="page-container">
    <component :is="currentContainer">
      <router-view v-if="isRouterAlive" />
    </component>
  </div>
</template>

<script setup lang="ts">
import { isMobile } from "@common_lib/base/utils/src/tools"
import { sendMessage } from "@/composables/useBridge"
import { safeSessionStorage } from "@/utils/safeStorage"

const googleAnalytics = useGoogleAnalytics()

console.log("test for code only jobs")

useModalStore()
useNavbarStore()

useFraudProtectionSystem()
useReceiveMessage()

// PostMessage 處理 iframe 關閉訊息
const { handleIframeCloseQuery } = usePostMessage()
handleIframeCloseQuery()

const {
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
} = useJBLWebSocket()

useChangeLine({
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
})

useLabelTerms()
useChat()

const components = {
  MobileContainer: defineAsyncComponent(() => import("@/layouts/mobile/Container.vue")),
  DesktopContainer: defineAsyncComponent(() => import("@/layouts/desktop/Container.vue"))
}

const currentContainer = computed(() =>
  isMobile() ? components.MobileContainer : components.DesktopContainer
)

const websiteInfoStore = useWebsiteInfoStore()
const { isRouterAlive, state } = storeToRefs(websiteInfoStore)
const authStore = useAuthStore()
const { isLogin, certification } = storeToRefs(authStore)
const { fetchAccountTracker } = useFetchAccountTracker()

const ACCOUNT_TRACKER_SESSION_KEY = "accountTrackerCalled"

const callAccountTracker = () => {
  if (safeSessionStorage.getItem(ACCOUNT_TRACKER_SESSION_KEY)) return
  safeSessionStorage.setItem(ACCOUNT_TRACKER_SESSION_KEY, "true")
  fetchAccountTracker().catch(err =>
    console.error("[App] accountTracker API failed", err)
  )
}

watch(
  () => state.value.userID,
  (newVal, oldVal) => {
    if (newVal && !oldVal) {
      callAccountTracker()
    }
    if (!newVal) {
      safeSessionStorage.removeItem(ACCOUNT_TRACKER_SESSION_KEY)
    }
  }
)

watch(
  () => certification.value.isPassLoginAPI,
  isPassLoginAPI => {
    if (isPassLoginAPI) callAccountTracker()
  }
)

useBridge()

onMounted(() => {
  if (state.value.userID) {
    callAccountTracker()
  }

  googleAnalytics.initialize()

  /**
   * APP 橋接
   */
  if (state.value.isMobileAppActive) {
    const cricketUrl = `${window.location.origin}/#/?AppHomeBtn=true`
    sendMessage(
      JSON.stringify({
        sessionId: state.value.queryPass,
        platform: "cricket",
        cricketUrl
      })
    )
    sendMessage(JSON.stringify({ isShowHomeButton: "true" }))

    if (isLogin.value) {
      sendMessage(`{"userId":"${state.value.userID}"}`)
    }
  }
})
</script>

<style lang="scss" scoped></style>
